Vue.component("file_type_icon", {
  mounted() {
  },
  props: ["type"],
  template: `
    <img v-if="type === 'video'" src="/learn/static/imgs/video-icon.svg" />
    <img v-else-if="type === 'audio'" src="/learn/static/imgs/audio-icon.svg" />
    <img v-else-if="type === 'document'" src="/learn/static/imgs/doc-icon.svg" />
    <img v-else-if="type === 'homework'" src="/learn/static/imgs/homework-icon.svg" />
    <img v-else-if="type === 'hyperlink'" src="/learn/static/imgs/hyperlink-icon.svg" />
    <img v-else-if="type === 'picture'" src="/learn/static/imgs/img-icon.svg" />
    <img v-else-if="type === 'material'" src="/learn/static/imgs/material-icon.svg" />
    <img v-else src="/learn/static/imgs/unknown.svg" />
  `,
});